import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Typography,
  Card,
  CardActions,
  CardContent,
  IconButton
} from '@material-ui/core';
import DoughnutChart from './DoughnutChart';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';

const EvaluationWithChart =
  ({ nameToDisplay, valueToDisplay, rateable, handleDialogeOpen, color }) => {
    const useStyles = makeStyles({
      root: {
        width: '138px',
        background: '#F4F4F4',
        minHeight: '146px',
        borderRadius: '4px 0px 0px 4px',
        color: '#666666',
        margin: '10px 0px 10px 0px',
        borderColor: '#F4F4F4'
      },
      name: {
        fontWeight: 'Bold',
        marginTop: '3px',
        fontSize: '12px'
      },
      cardAction: {
        padding: 0,
        position: 'absolute',
        zIndex: 100
      },
      button: {
        padding: 11,
        paddingTop: 11,
        color: '#76C9E6'
      }
    });

    const classes = useStyles();

    return (
      <Card className={ classes.root } variant = { 'outlined' }>
        {
          rateable && <CardActions className = { classes.cardAction }>
            <IconButton
              onClick={ () => handleDialogeOpen() }
              aria-label="edit"
              className={ classes.button }>
              <CreateOutlinedIcon />
            </IconButton>
          </CardActions>
        }
        <CardContent>
          <DoughnutChart
            valueToDisplay = { valueToDisplay }
            color = { color }
          />
          <Grid
            align="center"
            container
            direction="column"
            justifyContent="center"
            spacing={ 0 }
          >
            <Typography className={ classes.name } component='div'>
              { nameToDisplay }
            </Typography>
          </Grid>
        </CardContent>
      </Card>
    );
  };

export default EvaluationWithChart;
